import { IKeyedInPartition, KeyedInPartition } from "./KeyedInPartition";
import IDirectionData from "../direction/directionData";
import { IKeyedInDirection, KeyedInDirection } from "./IKeyedInDirection";
import { ND } from "../../utilities/Constants";

export interface IKeyedInProperty {
  id: string;
  name: string;
  defaultDirection: IDirectionData;
  partitionsCount: number;
  partitions: IKeyedInPartition[];
  setPartitions(defaultDirection: any, partitionsCount: number): void;
  removePartition(partition: IKeyedInPartition): void;
  updatePartition(partition: IKeyedInPartition): void;
}

export class KeyedInProperty implements IKeyedInProperty {
  id: string;
  name: string;
  defaultDirection: IDirectionData;
  partitionsCount: number;
  partitions: IKeyedInPartition[];

  _count: number = 1;

  constructor(id: string, name: string, defaultDirection: IDirectionData) {
    this.id = id;
    this.name = name;
    this.partitionsCount = 1;
    this.partitions = [];
    const d = defaultDirection;
    d.name === ND ? d.name = "--" : d.name = d.name
    this.defaultDirection = d;
    this.setPartitions(null, this.partitionsCount);
  }

  public setPartitions(defaultDirection: any, partitionsCount: number): void {
    this.partitionsCount = partitionsCount;
    this.partitions.splice(0);
    const defaultDirectionArray: IKeyedInDirection[] = [];
    if (defaultDirection === null) {
      defaultDirectionArray.push(new KeyedInDirection(this.defaultDirection.id, this.defaultDirection.name, 1));
      for (let index = 0; index < this.partitionsCount; index++) {
        this.partitions.push(new KeyedInPartition(index, "", defaultDirectionArray));
      }
    } else {
      defaultDirectionArray.push(new KeyedInDirection(defaultDirection.id, defaultDirection.name, 1));
      for (let index = 0; index < this.partitionsCount; index++) {
        this.partitions.push(new KeyedInPartition(index, "", defaultDirectionArray));
      }
    }

  }

  public removePartition(partition: IKeyedInPartition) {
    if (this.partitionsCount > 0) {
      this.partitionsCount = this.partitionsCount - 1;
      this.partitions.splice(partition.index, 1);
    }
  }

  public updatePartition(partition: IKeyedInPartition): void {
    partition.isEdit = false;
    const newPartitions: IKeyedInPartition[] = [];
    this.partitions.forEach((element: IKeyedInPartition) => {
      const directions: IKeyedInDirection[] = [];
      element.directions.forEach((el, i: number) => {
        if(element.index === partition.index) {
          const directionData = {
            ...el,
            count: el.count,
            id: partition.directions[0].dropdown[0].value,
            name: partition.directions[0].dropdown[0].label,
            dropdown: partition.directions[0].dropdown
          }
          directions.push(directionData)
        }else{
          const directionData = {
            ...el,
            count: el.count,
            id: el.dropdown[0].value,
            name: el.dropdown[0].label,
            dropdown: el.dropdown
          }
          directions.push(directionData)
        }
        
      })
      const elm = {
        isEdit: element.isEdit,
        index: element.index,
        name: element.name,
        directions
      }
      newPartitions.push(elm)
    });
    this.partitions = newPartitions;
    this.partitions[partition.index] = partition;
  }

}